import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { fetchData } from '../../../helpers/methods';

import SpinnerContainer from '../../../component-library/spinner-container';
import SearchCard from '../../../component-library/search-card';

const TopApis = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);

	const getData = () => {
		setLoading(true);
		fetchData({
			uri: '/api/web/metrics/top',
			method: 'GET',
		})
			.then(res => {
				const newData = res.body.metrics;
				setData(newData);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
			});
	};

	const handleCardClick = id => {
		navigate(`../details/${id}`, { state: { from: 'topapis' } });
	};

	useEffect(() => {
		getData();
	}, []);

	return (
		<div>
			<h2>Top APIs</h2>
			{loading && (
				<SpinnerContainer />
			)}
			{!loading && (
				data?.length > 0 ? (
					<>
						{data.map((section, index) => (
							// eslint-disable-next-line react/no-array-index-key
							<div key={index} className={`margin-bottom-24 padding-bottom-8 ${data.length !== (index + 1) && 'border-bottom'}`}>
								<h3 className="text-capitalize">{section.label}</h3>
								<div className="search__results-grid">
									{section.items.length > 0 ? (
										section.items.slice(0, 4).map((result, resultIndex) => (
											<SearchCard
												// eslint-disable-next-line react/no-array-index-key
												key={resultIndex}
												id={result.item.id}
												title={result.item.name}
												interfaceType={result.item.interfaceType.name}
												version={result.item.version}
												description={result.item.description}
												state={result.item.state}
												division={result.item.division}
												favourite={result.item.userFavourite}
												subscribed={result.item.userWatched}
												objectType={result.item.objectType}
												handleCardClick={id => handleCardClick(id)}
												showMetrics
												metricLabel={`${section.metric.label} Per ${section.timeUnit.label}`}
												metricValue={result.value}
											/>
										))
									) : (
										<p className="grey-text margin-bottom-none">No results found</p>
									)}
								</div>
							</div>
						))}
					</>
				) : (
					<p className="grey-text text-center margin-top-24 margin-bottom-none">No results found</p>
				))}
		</div>
	);
};

export default TopApis;
